import Point from "slotworks/utils/geom/point";
import Result from "./result";

export default class CascadeResult extends Result {

    public resultType: string = "CascadeResult";
    public cascades: Point[];

    constructor(cascades: Point[]) {
        super();
        this.cascades = cascades;
    }
}
